import { useState } from 'react';
import toast from 'react-hot-toast';
import { useIrsForms, downloadIrsForm } from '../../../api/irs';
import { PageMeta } from '../shared/PageMeta';
import { EmptyState } from '../shared/EmptyState';

export function IrsFormsPage() {
  const { data: forms, isLoading } = useIrsForms();
  const [downloadingId, setDownloadingId] = useState<number | null>(null);

  const handleDownload = async (donationId: number) => {
    setDownloadingId(donationId);
    try {
      await downloadIrsForm(donationId);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Download failed');
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <PageMeta title="IRS Forms" description="Download your IRS Form 8283 for tax deductions" path="/marketplace/irs-forms" />
      <h2 className="text-3xl mb-6">IRS Forms (8283)</h2>
      <p className="text-spi-slate mb-6">Download your IRS Form 8283 for noncash charitable contributions to claim tax deductions.</p>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
        </div>
      ) : forms?.length ? (
        <div className="space-y-3">
          {forms.map((form) => (
            <div key={form.id} className="card p-5 flex items-center justify-between">
              <div>
                <h4 className="font-semibold text-spi-charcoal">{form.formData.description}</h4>
                <p className="text-sm text-spi-slate">
                  Donation #{form.donationId} &middot; ${form.formData.fairMarketValue.toLocaleString()} &middot; {new Date(form.createdAt).toLocaleDateString()}
                </p>
              </div>
              <button
                onClick={() => handleDownload(form.donationId)}
                disabled={downloadingId === form.donationId}
                className="btn btn-outline text-sm py-2 px-4"
              >
                {downloadingId === form.donationId ? 'Downloading...' : 'Download PDF'}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState
          title="No IRS forms yet"
          description="IRS Form 8283 documents will be generated after your seed donations are verified by an admin."
        />
      )}
    </div>
  );
}
